// extracted by mini-css-extract-plugin
module.exports = {"main":"group-control_main__3MfNI"};